module.exports = __webpack_public_path__ + "static/overlay-488dcb2b2ddb501c9d5ed3fef7f48805.png";